import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom"

import { useTranslation } from "react-i18next";

import logo from "../img/logo.svg"

import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function MobileMenu() {

    const { link } = useContext(LinkContext);

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const location = useLocation();

    const { t } = useTranslation();

    return (
        <div>
            <div className="relative z-[999] w-[30px] h-[10px] cursor-poroboto flex flex-col justify-between xl:hidden" onClick={toggleMenu}>
                <div className={`w-full h-[1px] transition duration-300 transform ${isOpen ? 'rotate-45 translate-y-[1px] bg-[#1F1F1FB2] w-[35px]' : 'bg-[#1F1F1FB2]'}`}></div>
                <div className={`w-full h-[1px]  transition duration-300 transform ${isOpen ? '-rotate-45 -translate-y-[9px] bg-[#1F1F1FB2] w-[35px]' : 'bg-[#1F1F1FB2]'}`}></div>
            </div>
            <div className={`fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-[#F1F1F1] z-50 transform transition-all duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <div className="flex flex-col items-center mt-[50px] gap-[15px]">
                    <img src={logo} alt="" className="w-[60px]"/>
                    <Link to="/trading"><p onClick={toggleMenu} className={`${location.pathname === '/trading' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[18px] hover:font-[500] transition-all mt-[40px]`}>{t('header.1')}</p></Link>
                    <Link to="/account"><p onClick={toggleMenu} className={`${location.pathname === '/account' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[18px] hover:font-[500] transition-all`}>{t('header.2')}</p></Link>
                    <Link to="/fees"><p onClick={toggleMenu} className={`${location.pathname === '/fees' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[18px] hover:font-[500] transition-all`}>{t('header.3')}</p></Link>
                    <Link to="/education"><p onClick={toggleMenu} className={`${location.pathname === '/education' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[18px] hover:font-[500] transition-all`}>{t('header.4')}</p></Link>
                    <Link to="/about"><p onClick={toggleMenu} className={`${location.pathname === '/about' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[18px] hover:font-[500] transition-all`}>{t('header.5')}</p></Link>
                    <Link to="/offers"><p onClick={toggleMenu} className={`${location.pathname === '/offers' ? 'text-[#35AB33]' : 'text-[#1F1F1FB2]'} ibm-plex text-[18px] hover:font-[500] transition-all`}>{t('header.7')}</p></Link>
                    <a href={link}>
                        <div className="py-[10px] px-[20px] rounded-[40px] bg-[#35AB33] hover:scale-[0.95] transition-all">
                            <p className="text-[#fff] ibm-plex text-[16px]">{t('header.6')}</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;